import server from '../../api/server'
import utils from '../../api/utils'
import formats from '../../api/formats'
import StoreClasses from './StoreClasses'

// import moment from 'moment'

const state = {
  constant: {
    ACTIVE_SCOPE: 'ACTIVE_SCOPE',
    ALL_SCOPE: 'ALL_SCOPE'
  },
  depoFileSet: new StoreClasses.ItemSet(item => item.uid),
  files: [],
  folders: [],
  paths: null,
  rootFolder: {
    fileName: 'root',
    path: '/',
    docName: 'Депозитарий'
  }
}

// getters
const getters = {
  getDepoUrl: (state, getters) => (uid) => {
    return getters.getOpenSettings.linkBaseUrl + '/depo/' + uid
  },
  getDepoFilesUrl: (state, getters) => (uids) => {
    var uidsStr = 'uids=' + uids.join(',')
    return getters.getOpenSettings.linkBaseUrl + '/depo?' + uidsStr
  },
  getDepoCurrentPath: (state, getters) => {
    return getters.getDepoFileSet.getFilter().path || '//root'
  },
  getDepoPathByFolder: (state, getters) => (folderName) => {
    let folder = state.folders.find(item => item.fileName === folderName) ||
    state.rootFolder
    return folder.path + '/' + folder.fileName
  },
  getDepoDisplayPaths: state => {
    return state.paths
  },
  getDepoFolderById: state => (uid) => {
    return state.folders.find(file => file.uid === uid)
  },
  getDepoFilteredFolders: (state, getters) => {
    var path = getters.getDepoCurrentPath
    return state.folders.filter(file => file.path.localeCompare(path) === 0)
  },
  getDepoFileSet: state => state.depoFileSet,
  getDepoPathFolders: (state, getters) => {
    var path = getters.getDepoCurrentPath
    var result = []
    if (path) {
      var fileNames = path.split('/')
      result = state.folders.filter(folder => fileNames.includes(folder.fileName))
    }
    return result
  },
  getDepoConstant: state => state.constant,
  renderDepoFileSignMessage: (state, getters) => (fileDto) => {
    return fileDto.signed ? `Я, ${fileDto.signText}, подтверждаю, что депонированный электронный документ (файл) равнозначен подлиннику документа на бумажном носителе. Подписано простой электронный подписью ${formats.formatDate(fileDto.signed)}.` : ''
  },
  renderDepoFileSignature: (state, getters) => (fileDto) => {
    var template = ''.concat(
      `<v-flex class="caption" v-if="fileDto && fileDto.signed">
        <span>{{getters.renderDepoFileSignMessage(fileDto)}}</span>
      </v-flex>`
    )
    return {
      template: template,
      data: function () {
        return {
          fileDto: fileDto,
          getters: getters
        }
      },
      methods: {
        formatDate: formats.formatDate
      }
    }
  }
}

// actions
const actions = {
  getDepoFile ({commit, state, getters}, uid) {
    return new Promise((resolve, reject) => {
      server.apiGet(
        '/api/me/depo/files/' + uid,
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении описания файла '})
          reject(e)
        }
      )
    })
  },
  getDepoFolder ({commit, state, getters}, uid) {
    return new Promise((resolve, reject) => {
      server.apiGet(
        '/api/me/depo/folder/' + uid,
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении описания файла '})
          reject(e)
        }
      )
    })
  },
  fetchDepoFiles ({commit, state, getters}) {
    if (getters.getProfileLoaded && getters.getProfileHaveClient !== true) {
      return
    }
    server.apiGet(
      '/api/me/depo/files',
      (data) => {
        commit('setDepoFiles', data)
        commit('setSuccessStatus')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка файлов из депозитария клиента '})
      }
    )
  },
  fetchDepoFileSet ({commit, state, getters}, force) {
    if (getters.getProfileLoaded && (getters.getProfileHaveClient !== true)) {
      return
    }
    if (!force && !state.depoFileSet.isChanged()) {
      return
    }
    var page = force ? 0 : state.depoFileSet.page
    let sort = state.depoFileSet.sort
    // console.log('fetchDepoFileSet', sort)
    var fxt = Object.assign({}, getters.getDepoFileSet.getFilter())
    commit('startDepoFileSet')
    server.apiGetParams(
      '/api/me/depo/files',
      {
        size: 20,
        page: page,
        sort: sort,
        request: {
          search: fxt.search,
          path: fxt.path,
          tags: fxt.tags && fxt.tags.join(', ') || null,
          scope: fxt.scope
        }
      },
      (data) => {
        commit('setDepoFileSet', {data: data, cxt: fxt})
        commit('setSuccessStatus')
      },
      (e) => {
        commit('stopDepoFileSet')
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка файлов из депозитария '})
      }
    )
  },
  fetchDepoFolders ({commit, state, getters}) {
    if (getters.getProfileLoaded && getters.getProfileHaveClient !== true) {
      return
    }
    server.apiGet(
      '/api/me/depo/folders',
      (data) => {
        commit('setDepoFolders', data)
        commit('setSuccessStatus')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка файлов из депозитария клиента '})
      }
    )
  },
  getDepoFileProp ({commit, state, rootState}, uid) {
    return new Promise((resolve, reject) => {
      server.openApiGet(
        '/depo/' + uid + '/prop',
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении описания файла '})
          reject(e)
        }
      )
    })
  },
  getDepoFileProps ({commit, state, rootState}, request) {
    return new Promise((resolve, reject) => {
      var uidsStr = request.uids.join(',')
      server.openApiGetParams(
        '/depo/props',
        {
          uids: uidsStr
        },
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении описания файлов '})
          reject(e)
        }
      )
    })
  },
  getDepoFileVersions ({commit, state, rootState}, uid) {
    return new Promise((resolve, reject) => {
      server.openApiGet(
        '/depo/' + uid + '/versions',
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении описания файла '})
          reject(e)
        }
      )
    })
  },
  fetchDepoFileProp ({commit, state, rootState}, uid) {
    server.openApiGet(
      '/depo/' + uid + '/prop',
      (data) => {
        commit('setDepoFileProp', data)
        commit('setSuccessStatus')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении описания файла '})
      }
    )
  },
  createDepoFolder ({commit, state, rootState}, fileItem) {
    server.apiPost(
      '/api/me/depo/folders',
      fileItem,
      (data) => {
        this.dispatch('fetchDepoFolders')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при изменении описания файла '})
      }
    )
  },
  updateDepoFolder ({commit, state, rootState}, fileItem) {
    server.apiPut(
      '/api/me/depo/folders/' + fileItem.uid,
      fileItem,
      (data) => {
        this.dispatch('fetchDepoFolders')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при изменении описания файла '})
      }
    )
  },
  deleteDepoFolder ({commit, state, rootState}, fileItem) {
    server.apiDelete(
      '/api/me/depo/folders/' + fileItem.uid,
      (data) => {
        this.dispatch('fetchDepoFolders')
        this.dispatch('fetchDepoFileSet', true)
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при удалении папки '})
      }
    )
  },
  updateDepoFile ({commit, state, rootState}, fileItem) {
    server.apiPut(
      '/api/me/depo/files/' + fileItem.uid,
      fileItem,
      (data) => {
        this.dispatch('fetchDepoFileSet', true)
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при изменении описания файла '})
      }
    )
  },
  updateDepoFilePaths ({commit, state, rootState}, request) {
    server.apiPost(
      '/api/me/depo/command-path-updates',
      {uids: request.uids, path: request.path},
      (data) => {
        this.dispatch('fetchDepoFolders')
        this.dispatch('fetchDepoFileSet', true)
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при изменении папки размещения файлов '})
      }
    )
  },
  updateDepoFileTags ({commit, state, rootState}, request) {
    server.apiPost(
      '/api/me/depo/command-tags-updates',
      {uids: request.uids, tags: request.tags},
      (data) => {
        this.dispatch('fetchDepoFileSet')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при меток файла '})
      }
    )
  },
  signDepoFiles ({commit, state, rootState}, request) {
    return new Promise((resolve, reject) => {
      server.apiPost(
        '/api/me/depo/command-file-signs',
        {uids: request.uids},
        (data) => {
          this.dispatch('fetchDepoFileSet')
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при заверении электронной копии документа '})
          reject(e)
        }
      )
    })
  },
  uploadDepoFile ({commit, state, rootState}, {fileItem, file}) {
    return new Promise((resolve, reject) => {
      var fd = new FormData()
      fd.append('file', file)
      fd.append('json', new Blob([JSON.stringify(fileItem)], {
        type: 'application/json'
      }))
      server.apiUpload(
        '/api/me/depo/files/',
        fd,
        (data) => {
          resolve(data.uid)
          this.dispatch('fetchDepoFileSet')
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при изменении описания файла '})
        }
      )
    })
  },
  uploadDepoFiles ({commit, state, rootState}, {docItem, files}) {
    let uids = []
    let count = files.length
    return new Promise((resolve, reject) => {
      files.forEach(file => {
        var meta = Object.assign({}, docItem, {
          fileName: file.name,
          fileExt: file.name.substring(file.name.lastIndexOf('.')),
          fileSize: file.size,
          docName: docItem.docName ? docItem.docName : file.name.substring(0, file.name.lastIndexOf('.'))
        })
        this.dispatch('uploadDepoFile', {fileItem: meta, file: file}).then(uid => {
          uids.push(uid)
          if (uids.length >= count) {
            resolve(uids)
          }
        })
      })
    })
  },
  copyDepoFileLink ({commit, state}, url) {
    utils.copyTextToClipboard(url)
    commit('setStatus', {show: true, type: 'success', message: 'Ссылка на файл скопирована в буфер обмена.'})
  }
}

// mutations
const mutations = {
// Set Api
  setDepoFileSetFilterContext (state, cxt) {
    state.depoFileSet.setFilter(cxt)
  },
  setDepoFileSetSort (state, sort) {
    state.depoFileSet.setSort(sort)
  },
  startDepoFileSet (state) {
    state.depoFileSet.clearChanged()
    state.depoFileSet.start()
  },
  stopDepoFileSet (state) {
    state.depoFileSet.stop()
  },
  nextDepoFileSet (state) {
    state.depoFileSet.nextPage()
  },
  setDepoFileSet (state, {data, cxt}) {
    state.depoFileSet.setItems(data, cxt)
    state.depoFileSet.stop()
  },
// Set Api end
  setDepoFolders (state, data) {
    state.folders = data
    state.folders.unshift(state.rootFolder)
    this.commit('setDepoPaths')
  },
  setDepoPaths (state) {
    var fs = state.folders.sort((a, b) => a.path ? a.path.localeCompare(b.path) : -1)
    var result = new Map()
    fs.forEach(folder => {
      var path = folder.path
      var dpath = result.get(path)

      if (!dpath) {
        dpath = folder.docName
      } else {
        dpath = dpath + '/' + folder.docName
      }
      result.set(folder.path + '/' + folder.fileName, dpath)
    })
    state.paths = result
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/depo.js